import { RegisteredComponent } from "@builder.io/sdk-react";

export const subnetCalculatorBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Subnet Calculator",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/education-technology/education-2/calculator-186.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "headline",
      friendlyName: "Headline",
      helperText:
        "Add headline text and optionally a tooltip. Use Text and Tooltip blocks.",
      type: "uiBlocks",
      defaultValue: [
        {
          "@type": "@builder.io/sdk:Element",
          component: {
            name: "Core:Box",
            options: {},
          },
          layerName: "Headline Container",
          responsiveStyles: {
            large: {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "var(--spacing-4, 16px)",
            },
            small: {
              justifyContent: "flex-start",
            },
          },
          children: [
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Text",
                options: {
                  text: {
                    "@type": "@builder.io/core:LocalizedValue",
                    Default: "<h2>Subnet Calculator</h2>",
                  },
                },
              },
              meta: {
                localizedTextInputs: ["text"],
                "transformed.text": "localized",
              },
              responsiveStyles: {
                large: {
                  fontWeight: "var(--font-weight-bold, 700)",
                  color: "var(--color-swdc-black-600, #111111)",
                  fontSize: "var(--text-headline-m, 2.375rem)",
                  lineHeight: "var(--text-headline-m--line-height, 3rem)",
                },
                small: {
                  fontSize: "var(--text-subhead-xl, 1.875rem)",
                  lineHeight: "var(--text-subhead-xl--line-height, 2.5rem)",
                  width: "auto",
                },
              },
            },
            {
              "@type": "@builder.io/sdk:Element",
              component: {
                name: "Tooltip",
                options: {
                  position: "bottom",
                  content: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "i",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "var(--spacing-5, 1.25rem)",
                          height: "var(--spacing-5, 1.25rem)",
                          borderRadius: "50%",
                          backgroundColor:
                            "var(--color-swdc-blue-500, #006482)",
                          fontSize: "var(--text-body-2xs, 0.75rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-swdc-white, #ffffff)",
                          cursor: "help",
                        },
                      },
                    },
                  ],
                  tooltipText: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default:
                              "Set IP Address and Subnet allocation, subnets are calculated after changing focus or pressing enter key.",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          backgroundColor: "var(--color-swdc-white, #ffffff)",
                          color: "var(--color-body-secondary, #666666)",
                          padding:
                            "var(--spacing-2, 8px) var(--spacing-3, 12px)",
                          borderRadius: "var(--radius-corner-subtle, 4px)",
                          fontSize: "var(--text-body-2xs, 0.75rem)",
                          lineHeight: "var(--text-body-2xs--line-height, 1rem)",
                          fontWeight: "var(--font-weight-medium, 500)",
                          maxWidth: "179px",
                          border:
                            "1px solid var(--color-swdc-gray-200, #a1a1a1)",
                          filter:
                            "drop-shadow(0 8px 16px rgba(27, 33, 44, 0.12))",
                        },
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
      ],
    },
    {
      name: "addressBlockHeadline",
      friendlyName: "Address Block Headline",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Address Block",
      },
    },
    {
      name: "allocationBlockHeadline",
      friendlyName: "Allocation Block Headline",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "Subnet Allocation",
      },
    },
    {
      name: "subnetsTableHeadline",
      friendlyName: "Subnets Table Headline",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "All Subnets",
      },
    },
  ],
  defaultStyles: {
    width: "100%",
  },
};
